import { CommitteeActions } from '..'
import { HttpServiceResponse } from '../../shared'
import { CommitteeParams } from '../models/committee-params.models'
import AbstractApplicationProvider from './application-abstract.provider'

export class CommitteeProvider extends AbstractApplicationProvider {
  urlPath = 'application_comittee_api'

  public committiee<T = any>(
    action: CommitteeActions,
    params: Partial<CommitteeParams>,
    rest: Record<string, unknown> = {},
  ): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.post(`${this.url}?${query}`, { ...rest })
  }
}
